import React, { useMemo } from 'react';

import { useMutation } from '@tanstack/react-query';

import Table from '../../../../../Table';
import DownloadLetterButton from './DownloadLetterButton';
import TrackingLink from './TrackingLink';

import { useUiContext } from '../../../../../../context/UiContext';
import DemandService from '../../../../../../services/DemandService';
import useUserRole from '../../../../../../hooks/useUserRole';

export default function DeliveriesTable({
  deliveries,
  /*  isActive, */
  demandId,
  refetch,
  demand,
}) {
  const { showDialogModal, showToast } = useUiContext();

  const { isSuperAdmin } = useUserRole();

  const { mutate: mailDemand } = useMutation({
    mutationFn: ({ deliveryId, demandType }) => {
      console.log('demandType', demandType);
      return DemandService.mailDemand({ demandId, deliveryId });
    },
    onSuccess: (data, variables) => {
      showToast({
        type: 'success',
        text:
          variables?.demandType === 'acceleration'
            ? 'Acceleration letter sent successfully'
            : 'Demand letter sent successfully',
      });
      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const { mutate: deleteDelivery } = useMutation({
    mutationFn: (documentId) => {
      return DemandService.updateDemand({
        demandId,
        formValues: {
          ...demand,
          payment_id: Array.isArray(demand?.payment_id)
            ? demand.payment_id.map((p) => p?.id)
            : demand?.payment_id,
          invoice_id: Array.isArray(demand?.invoice_id)
            ? demand.invoice_id.map((i) => i?.id)
            : demand?.invoice_id,
          delivery: demand.delivery.filter((d) => d.document_id !== documentId),
        },
      });
    },
    onSuccess: () => {
      showToast({
        type: 'success',
        text: 'Delivery deleted successfully',
      });
      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const cols = useMemo(
    () => [
      {
        title: 'Date',
        keys: ['date'],
        type: 'date',
      },
      {
        title: 'Type',
        keys: ['type'],
      },
      {
        title: 'Class',
        keys: ['delivery_type'],
      },
      {
        title: 'Tracking',
        keys: ['tracking_number'],
        type: 'component',
        // eslint-disable-next-line react/no-unstable-nested-components
        component: TrackingLink,
        props: (row) => ({ trackingNumber: row?._mail?.tracking_number }),
      },
      {
        title: 'Draft Letter',
        type: 'component',
        component: DownloadLetterButton,
        props: (row) => ({
          document: row?._document,
        }),
      },
      {
        title: 'Mailed Letter',
        type: 'component',
        component: DownloadLetterButton,
        props: (row) => ({
          document: row?._mail?._document,
        }),
      },
      {
        title: 'Status',
        keys: ['_mail.lob_status'],
        type: (row) => {
          if (!isSuperAdmin) {
            return 'text';
          }

          return row._mail ? 'text' : 'button';
        },
        label: () => 'Deliver',
        onClick: (row) => {
          showDialogModal({
            title: 'Confirmation',
            message:
              row.type === 'acceleration'
                ? 'Are you sure you want to mail this acceleration letter certified mail?'
                : 'Are you sure you want to mail this demand letter certified mail?',
            onConfirm: () => {
              mailDemand({
                deliveryId: row.delivery_id,
                demandType: row.type,
              });
            },
            confirmButtonLabel: 'Yes, send it',
            cancelButtonLabel: 'No, cancel',
          });
        },
      },
      {
        title: '',
        type: 'delete',
        isVisible: (row) => {
          return !row.mail_id;
        },
        onClick: (row) => {
          showDialogModal({
            title: 'Confirmation',
            type: 'danger',
            message: 'Are you sure you want to delete this delivery?',
            onConfirm: () => {
              deleteDelivery(row?.document_id);
            },
            confirmButtonLabel: 'Yes, delete it',
            cancelButtonLabel: 'No, cancel',
          });
        },
      },
    ],
    [deleteDelivery, isSuperAdmin, mailDemand, showDialogModal]
  );

  return (
    <div>
      <Table rows={deliveries} cols={cols} title="Deliveries" />
    </div>
  );
}
